define('lq/events/actions/changePassword',[
    'jquery',
    'lq',
    'lq/events/actions/eventAction'
], function ($, lq, EventAction) {
    'use strict';

    function ChangePassword(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ChangePassword, EventAction);

    ChangePassword.typeName = 'ChangePassword';

    ChangePassword.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    ChangePassword.prototype.getValueOf = function (dropName) {
        return this.piping.dropFactory
            .findDropByViewModelKey(dropName)
            .getValue();
    };
    
    ChangePassword.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'ChangePassword',
            command: this.eventData.command,
            newPassword: this.getValueOf(this.eventData.passwordField),
            newPasswordConfirmation: this.eventData.passwordConfirmationField ? this.getValueOf(this.eventData.passwordConfirmationField) : null,
            oldPassword: this.eventData.oldPasswordField ? this.getValueOf(this.eventData.oldPasswordField) : null
        };
    };

    ChangePassword.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse && eventActionResponse.status === 'invalidOldPassword') {
            return this.handleError('invalidOldPassword', 'The old password is wrong.', continuation);
        } else if (eventActionResponse && eventActionResponse.status === 'invalidPasswordConfirmation') {
            return this.handleError('invalidPasswordConfirmation', 'Passwords do not match.', continuation);
        } else if (eventActionResponse && eventActionResponse.status === 'invalidNewPassword') {
            return this.handleError('invalidNewPassword', 'The new password cannot be left empty.', continuation);
        } else if (eventActionResponse && eventActionResponse.status === 'invalidPasswordLength') {
            return this.handleError('invalidPasswordLength', 'The new password is too short.', continuation);
        } else if (eventActionResponse && eventActionResponse.status === 'invalidPasswordComplexity') {
            return this.handleError('invalidPasswordComplexity', 'The new password does not meet the complexity requirements.', continuation);
        } else if (eventActionResponse && eventActionResponse.status === 'newPasswordSameAsOldPassword') {
            return this.handleError('newPasswordSameAsOldPassword', 'The new password should be different from the previous password.', continuation);
        }

        if (this.eventIsEnabled('passwordChanged')) {
            this.triggerEvent('passwordChanged');
        }
        continuation();
    };

    ChangePassword.prototype.handleError = function (eventName, defaultMessage, continuation) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, function () {
                continuation({ break: true });
            });
        } else {
            alert(defaultMessage);
            continuation({ break: true });
        }
    };

    return ChangePassword;
});
